import TrafficBucket from './TrafficBucket.jsx';
import GroupBySwitch from './GroupBySwitch.jsx';
import FilterChipBar from './FilterChipBar.jsx';
import StageFilterChip from './StageFilterChip.jsx';
import NewButton from './NewButton.jsx';
import { formatTimeOfDay } from '@/lib/date-display.js';

export default function TrafficBoard({ data, onMutate, groupBy, onGroupByChange, filters, onFiltersChange, stageFilter, onStageFilterChange }) {
  const groups = data?.groups || [];
  const counts = data?.counts || {};
  const asOf = data?.asOf;

  const nonEmpty = groups.filter((b) => (b.items?.length || 0) > 0);
  const totalItems = groups.reduce((sum, b) => sum + (b.items?.length || 0), 0);

  const pills = [
    counts.overdue > 0 && `${counts.overdue} urgent`,
    counts.today > 0 && `${counts.today} today`,
    counts.week > 0 && `${counts.week} this week`,
  ].filter(Boolean);

  function handleFilterRemove(key) {
    const next = { ...filters };
    delete next[key];
    onFiltersChange?.(next);
  }

  return (
    <div className="mx-auto max-w-5xl space-y-4 p-4 md:p-6">
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <GroupBySwitch value={groupBy || 'urgency'} onChange={onGroupByChange} />
            <StageFilterChip selected={stageFilter || []} onChange={onStageFilterChange} />
          </div>
          <NewButton onSuccess={onMutate} />
        </div>
        <FilterChipBar filters={filters || {}} onRemove={handleFilterRemove} onClear={() => onFiltersChange?.({})} />
      </div>

      {/* Urgency legend — sticky at the top (4 levels only; no blue). */}
      <div className="sticky top-0 z-10 -mx-4 flex flex-wrap gap-x-4 gap-y-1 border-b border-border bg-bg/95 px-4 py-2 text-[11px] text-text-dim backdrop-blur md:-mx-6 md:px-6">
        <span className="inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-accent" />Overdue</span>
        <span className="inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-warning" />This week</span>
        <span className="inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-success" />Later</span>
        <span className="inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-text-dim" />No urgency</span>
      </div>

      {pills.length > 0 && groupBy === 'urgency' ? (
        <div className="flex items-center gap-2 text-xs text-text-dim">
          {pills.join(' · ')}
        </div>
      ) : null}

      {totalItems === 0 ? (
        <div className="flex min-h-[30vh] items-center justify-center">
          <p className="text-sm text-text-muted">No open work.</p>
        </div>
      ) : (
        nonEmpty.map((bucket) => (
          <TrafficBucket key={bucket.key} bucket={bucket} onMutate={onMutate} forceExpand={groupBy !== 'urgency'} />
        ))
      )}

      {asOf ? (
        <p className="text-center text-[10px] text-text-dim">
          as of {formatTimeOfDay(asOf)}
        </p>
      ) : null}
    </div>
  );
}
